import { useEffect, useState } from 'react';
import { fetchDosageDiaryProducts } from '../service/fetchDosageDiaryProducts';
import showToast from '../components/ToastComponent';
import { FetcHDosageDiaryProductResult } from '../interface/interface';

export function useToFetchAllocatedDosageDiaryProducts(
  token: string,
  fetchCounter: boolean,
): [(val: string) => void, Array<FetcHDosageDiaryProductResult>] {
  const [profileId, setProfileId] = useState<string>();
  const [assignedProducts, setAssignedProducts] = useState<
    Array<FetcHDosageDiaryProductResult>
  >([]);

  useEffect(() => {
    if (!profileId) return;

    fetchDosageDiaryProducts(token, {
      allocated: true,
      profileId,
    }).then((res) => {
      if (typeof res === 'number') {
        showToast({
          type: 'info',
          message: 'Unable to fetch allocated products',
        });
        return;
      }

      setAssignedProducts(res);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileId, fetchCounter]);

  function setProfileIdHandler(id: string) {
    setProfileId(id);
  }

  return [setProfileIdHandler, assignedProducts];
}
